module.exports = __webpack_public_path__ + "static/img/professional.ba4debf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/contact/professional.png
// module id = XWZN
// module chunks = 1